<template>
  <v-app>
    <v-app-bar app elevate-on-scroll dark color="primary" clipped-left>
      <v-app-bar-nav-icon v-on:click.stop="navigation = !navigation"></v-app-bar-nav-icon>
      <v-toolbar-title class="headline linked">
        <img class="logo-brand" src="@/assets/logo-white-square.svg" alt="SSASS Cashier logo"/>
        <span class="font-weight-light hidden-sm-and-down">Cashier</span>
      </v-toolbar-title>
      <v-autocomplete flat solo-inverted hide-details clearable
        prepend-inner-icon="mdi-magnify" placeholder="Search" class="hidden-xs-and-down mx-2 ml-5" 
        hide-no-data v-bind:items="items" open-on-clear v-on:change="open" return-object>
        <template v-slot:item="{item}">
          <v-list-item-icon>
            <v-icon>{{item.icon}}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            {{item.text}}
          </v-list-item-content>
        </template>
      </v-autocomplete>
      <v-spacer class="hidden-sm-and-up"/>
      <v-btn icon v-on:click="$router.push({name: 'payment'}).catch(err => {})">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      <v-menu offset-y v-bind:close-on-content-click="false"
          max-width="250" min-width="250">
        <template v-slot:activator={on}>
          <v-btn icon v-on="on">
            <v-badge color="success">
              <template v-slot:badge>
                5
              </template>
              <v-icon>mdi-bell-outline</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <v-card tile>
          <v-list class="py-0" tile>
            <v-list-item v-on:click="$router.push({name: 'history', query: {
                  tab: 'accepted'
                }}).catch(err => {})" two-line>
              <v-list-item-content>
                <v-list-item-title>
                  Firdavs Beknazarov
                </v-list-item-title>
                <v-list-item-subtitle class="success--text">Order has been accepted</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-on:click="$router.push({name: 'history', query: {
                  tab: 'rejected',
                }}).catch(err => {})" two-line>
              <v-list-item-content>
                <v-list-item-title>
                  Firdavs Beknazarov
                </v-list-item-title>
                <v-list-item-subtitle class="red--text">Order has been rejected</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-btn text block color="success"
              v-on:click="$router.push({name: 'history'}).catch(err => {})">
            View all
          </v-btn>
        </v-card>
      </v-menu>
      <v-menu offset-y max-width="250" min-width="250"
          v-bind:close-on-content-click="false">
        <template v-slot:activator="{on}">
          <v-btn icon v-on="on">
            <v-icon>mdi-account</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-list>
            <v-list-item>
              <v-list-item-icon><v-icon large>mdi-account</v-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Firdavs Beknazarov</v-list-item-title>
                <v-list-item-subtitle>SEO</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn text><v-icon>mdi-logout</v-icon>logout</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer v-model="navigation" app clipped color="primary" dark mini-variant
      mini-variant-width="60">
      <v-list class="py-0">
        <v-tooltip right>
          <template v-slot:activator="{on}">
            <v-list-item to="/" v-on="on">
              <v-list-item-icon>
                <v-icon>mdi-view-dashboard</v-icon>
              </v-list-item-icon>
              <v-list-item-content />
            </v-list-item>
          </template>
          <span>Dashboard</span>
        </v-tooltip>
        <v-tooltip right>
          <template v-slot:activator="{on}">
            <v-list-item to="/history" v-on="on">
              <v-list-item-icon>
                <v-badge color="success" dot>
                  <v-icon>mdi-checkbox-multiple-blank</v-icon>
                </v-badge>
              </v-list-item-icon>
              <v-list-item-content />
            </v-list-item>
          </template>
          <span>History</span>
        </v-tooltip>
        <v-tooltip right>
          <template v-slot:activator="{on}">
            <v-list-item to="/employees" v-on="on">
              <v-list-item-icon>
                <v-icon>mdi-account-card-details</v-icon>
              </v-list-item-icon>
              <v-list-item-content />
            </v-list-item>
          </template>
          <span>Employees</span>
        </v-tooltip>
        <v-tooltip right>
          <template v-slot:activator="{on}">
            <v-list-item to="/organizations" v-on="on">
              <v-list-item-icon>
                <v-icon>mdi-domain</v-icon>
              </v-list-item-icon>
              <v-list-item-content />
            </v-list-item>
          </template>
          <span>Organizations</span>
        </v-tooltip>
        <!--<v-tooltip right>
          <template v-slot:activator="{on}">
            <v-list-item to="/customers" v-on="on">
              <v-list-item-icon>
                <v-icon>mdi-account-multiple</v-icon>
              </v-list-item-icon>
              <v-list-item-content />
            </v-list-item>
          </template>
          <span>Customers</span>
        </v-tooltip>-->
        <v-tooltip right>
          <template v-slot:activator="{on}">
            <v-list-item to="/settings" v-on="on">
              <v-list-item-icon>
                <v-icon>mdi-settings</v-icon>
              </v-list-item-icon>
              <v-list-item-content />
            </v-list-item>
          </template>
          <span>Settings</span>
        </v-tooltip>
      </v-list>
    </v-navigation-drawer>
    <v-content>
      <v-container>
        <slot />
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
export default {
  name: 'v-application',
  data: () => ({
    navigation: true,
    items: [
      {id: 1, text: 'Beknazarov Firdavs', icon: 'mdi-account-circle', type: 'employee'},
      {id: 1, text: 'Asia Alliance Bank', icon: 'mdi-domain', type: 'organization'}
    ],
  }),
  methods: {
    open(item){
      var go = {
        name: item.type,
        params: {id: item.id},
        query: {back: this.$route.name}
      }
      this.$router.push(go)
    }
  },
  mounted(){
    var mode = localStorage.getItem('mode')
    var path = this.$route.path
    if(path !== '/404' && mode !== 'dev'){
      this.$router.push({path: '/404'})
    }
  }
}
</script>
